export const userActivityEvents = {
    MOUSE_MOVE: "mousemove",
    KEY_PRESS: "keypress",
    SCROLL: "scroll",
    TOUCH_MOVE: "touchmove",
    TOUCH_START: "touchstart",
    TOUCH_END: "touchend",
    MOUSE_DOWN: "mousedown",
    MOUSE_UP: "mouseup",
};